import axios from "axios";
import {
  clearStoredIdToken,
  getStoredIdToken,
  getStoredTokenExpiryMs,
  getTokenExpiryFromJwt,
  persistIdToken,
} from "./lib/tokenUtils";
import { getFreshIdToken } from "./lib/firebaseAuth";

/*const apiUrl = process.env.REACT_APP_API_BASE_URL;*/
const baseURLs = {
  localhost:
    "https://api-lrp-dashboard-uat.azurewebsites.net/api/v1",
  "ui-lrportal-dev-eus.azurewebsites.net":
    "https://api-lrp-dashboard-uat.azurewebsites.net/api/v1",
  "ui-lrportal-test-eus.azurewebsites.net":
    "https://api-lrp-dashboard-test.azurewebsites.net/api/v1",
  "ui-lrportal-uat-eus.azurewebsites.net":
    "https://api-lrp-dashboard-uat.azurewebsites.net/api/v1",
  // 'ui-lrportal-prod-eus.azurewebsites.net':'https://api-lrportal-prod-eus.azurewebsites.net/api/v1',
  "www.taxraven.com": "https://api-lrp-dashboard-uat.azurewebsites.net/api/v1",
  "ui-lrportal-prod-eus-staging.azurewebsites.net":
    "https://api-lrp-dashboard-uat.azurewebsites.net/api/v1",
  "lrp-test.canaryai.com":
    "https://api-lrp-dashboard-test.azurewebsites.net/api/v1",
  "web-lrp-dashboard-test.azurewebsites.net":
    "https://api-lrp-dashboard-test.azurewebsites.net/api/v1",
  // Add more mappings as needed
};
const hostName = window.location.hostname;
const apiUrl =
  baseURLs[hostName] ||
  `https://api-lrp-dashboard-uat.azurewebsites.net/api/v1`;
// const apiUrl = `
// https://api-lrportal-dev-eus.azurewebsites.net/api/v1`;

const axiosInstance = axios.create({
  baseURL: apiUrl,
  withCredentials: true,
});
// const history = createBrowserHistory();
// const navigate = useNavigate();
const EXPIRY_SAFETY_WINDOW_MS = 2 * 60 * 1000;

const ensureIdToken = async (forceRefresh = false) => {
  try {
    const token = await getFreshIdToken(forceRefresh);
    if (token) return token;
  } catch (error) {
    console.error(
      `Silent token refresh (${forceRefresh ? "force" : "cache"}) failed:`,
      error
    );
  }
  return null;
};

axiosInstance.interceptors.request.use(
  async (config) => {
    let idToken = getStoredIdToken();
    let expiryMs = getStoredTokenExpiryMs();

    if (idToken && !expiryMs) {
      const computedExpiry = getTokenExpiryFromJwt(idToken);
      if (computedExpiry) {
        localStorage.setItem("idTokenExpiryMs", String(computedExpiry));
        expiryMs = computedExpiry;
      }
    }

    const now = Date.now();
    const shouldRefresh =
      !idToken ||
      (expiryMs !== null && expiryMs - now <= EXPIRY_SAFETY_WINDOW_MS);

    if (shouldRefresh) {
      const force = expiryMs !== null && expiryMs <= now;
      const refreshed = await ensureIdToken(force);
      if (refreshed) {
        idToken = refreshed;
        try {
          sessionStorage.removeItem("authExpired");
        } catch {
          // ignore storage errors
        }
      }
    }

    if (idToken) {
      config.headers.Authorization = `Bearer ${idToken}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Add a response interceptor to handle token refresh on 401
axiosInstance.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config || {};
    const status = error?.response?.status;

    const retryCount = originalRequest._retryCount || 0;
    if (status === 401 && retryCount < 1) {
      originalRequest._retryCount = retryCount + 1;
      const refreshed = await ensureIdToken(true);
      if (refreshed) {
        originalRequest.headers = originalRequest.headers || {};
        originalRequest.headers.Authorization = `Bearer ${refreshed}`;
        return axiosInstance(originalRequest);
      }

      clearStoredIdToken();
      try {
        sessionStorage.setItem("authExpired", "1");
      } catch {
        // ignore storage errors
      }
      if (typeof window !== "undefined" && window.location.pathname !== "/") {
        window.location.pathname = "/";
      }
    }

    return Promise.reject(error);
  }
);
// axiosInstance.interceptors.response.use(
//   (response) => response,
//   (error) => {
//     if (error.response &&  error.response.status === 401) {
//       // Clear local storage or any other logout logic

//       localStorage.clear();

//       // Redirect to login page
//       // history.push('/');
//       if(window.location.pathname !=='/') {
//         window.location.pathname = '/';
//       }
//     }
//     return Promise.reject(error);
//   }
// );

export default axiosInstance;
